import React ,{  useContext } from "react";
import "../StudyPlannerImages.css";
import { AuthContext } from "../Hook/AuthProvider";
function StudyPlannerImages({ headline, para, keynotes,type,pro }) {
  const {profileData } = useContext(AuthContext);
  return (
    <div className={`root-div-Studyplannerimages ${pro && profileData?.user_type !="pro" ? "notpro" : "pro"}`}
 style={{ display: "flex" }}>
      <div className="parent-div-Studyplannerimages">
        <div className="headline-Studyplannerimages-main">
           <div className="headline-Studyplannerimages">{headline}</div>
            {type && (<div className="type-container"> <img src="/assets/images/stdplanner-type-icon.svg" alt="" /><span className="type-style">{type}</span></div>)}
            {pro && (<div className="probutton-study-planner-div"> <img src="/assets/images/pro-button-gradient-1.svg" alt=""   style={{height:"24px",marginTop:"5px",marginLeft:"10px"}}/></div>)}
        </div>
     
        <div className="para-Studyplannerimages">{para}</div>
        <div className="images-container">
          {keynotes &&
            keynotes.map((keynote, index) => (
              <span key={index} className="keys-studyplanner">
                <img src="/assets/images/confirmation-new.svg" alt="" className="img-confirmation"/>{keynote}
              </span>
            ))}
        </div>
      </div>

      <div className="img-Studyplanner">
        <img src="/assets/images/study-planner-cardimg.svg" className="img-study-planner" alt="" />
      </div>
    </div>
  );
}

export default StudyPlannerImages;
